"use client";

import React from "react";

const localStorage = typeof window !== "undefined" ? window.localStorage : null;

export function useLocalStorageState<S>(
  key: string,
  defaultValue: S
): [S, (value: S) => void] {
  const [state, setState] = React.useState<S>(() => {
    const value = localStorage?.getItem(key);
    let result = defaultValue;
    if (value) {
      try {
        result = JSON.parse(value);
      } catch (error) {
        console.error("Error parsing localStorage value", error);
      }
    }
    return result;
  });

  const setLocalStorageState = (value: S) => {
    localStorage?.setItem(key, JSON.stringify(value));
    setState(value);
  };

  return [state, setLocalStorageState];
}
